import { render, staticRenderFns } from "./SpecificationPanel.vue?vue&type=template&id=615d5d3e&"
import script from "./SpecificationPanel.vue?vue&type=script&lang=js&"
export * from "./SpecificationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports